import './style.scss';
import Reports from '../reports/Reports';
import SectorReports from '../reports/SectorReports';
import Splash from '../splash/Splash';
import PSSplash from '../splash/PSSplash';
import { useTranslation } from "react-i18next";
import CookieService from '../../shared/cookieService';
import { useState, useEffect } from 'react';
const SubmissionTool = () => {
    //let isSector = true;
    const [isSector, setIsSector] = useState(window.localStorage.IUCN_USER_GROUP === 'PrivateSector' ? true : false);
    //let isSector =window.localStorage.IUCN_USER_GROUP === 'PrivateSector' ? true : false;
    const isAdmin = window.localStorage.IUCN_ADMIN_GROUP === 'Admin' ? true : false;
    const showBoth = window.localStorage.IUCN_VIEW_GROUP === 'Both' ? true : false;
    const { t } = useTranslation('submissionTool');

    const SectorSelected = (viewType: any) => {
        if (viewType == 'Country') {
            setIsSector(false);
        }
        else {
            setIsSector(true);
        }
        window.localStorage.setItem(CookieService.SESSION_USER_GROUP, viewType);
    }
    useEffect(() => {
    }, [isSector],
    );
    return isSector ?
        (
            <div className="sectorSubmissionDiv" style={{ backgroundImage: `url("${process.env.PUBLIC_URL}/assets/background/submission-bg.svg")` }}>

                <div className="row veryBigText pageTitle">
                    <span>{t('title')}</span>
                </div>

                <div className="wrapper">
                    {(isAdmin ||showBoth) &&
                        <>
                            <div className="switchDiv">
                                <ul className="switchList">
                                <li>
                                        <button className="switchleft" title="Country"  onClick={() => SectorSelected('Country')}>Country</button>
                                    </li>
                                    <li>
                                        <button className="switchright activeTab" title="Private Sector" onClick={() => {SectorSelected('PrivateSector')}}>Private Sector</button>
                                    </li>
                                </ul>
                            </div>
                        </>
                    }
                    <SectorReports />
                    <PSSplash />
                </div>
            </div>
        ) :
        <div className="submissionDiv" style={{ backgroundImage: `url("${process.env.PUBLIC_URL}/assets/background/submission-bg.svg")` }}>

            <div className="row veryBigText pageTitle">
                <span>{t('title')}</span>
            </div>

            <div className="wrapper">
                {(isAdmin ||showBoth) &&
                    <>
                        <div className="switchDiv">
                            <ul className="switchList">
                                <li>
                                    <button className="switchleft activeTab" title="Country" onClick={() => SectorSelected('Country')}>Country</button>
                                </li>
                                <li>
                                    <button className="switchright" title="Private Sector" onClick={() => {SectorSelected('PrivateSector')}}>Private Sector</button>
                                </li>
                            </ul>
                        </div>
                    </>
                }
                <Reports />
                <Splash />
            </div>
        </div>
};

export default SubmissionTool